import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Modal from "react-modal";
import { AlertaError } from "../.././../Stores/Funcoes/FuncoesGerais";
import { Button, Col, Form, InputGroup, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { BottomModal } from "../../Modal/BottomModal";
import ModalHeard from "../../Modal/ModalHeard";
import InputMask from "react-input-mask";
import { FormLabelModal } from "../../Modal/LabelModal";
import { DivUser } from "../Style/style";
import { ChevronsDown, ChevronsUp, X } from "react-feather";
import Api from "../../../Stores/Conexao/conexao";
@inject("ClienteStores", "ClienteEmpresaStores")
@observer
class ModalEditarEmpresaHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clienteId: "",
      clienteName: "",
      isActive: false,
      clientes: [],
      valueCliente: "",
      status: false,
      arrayUsuarios: [],
    };
  }

  handleCloseModal = () => {
    this.props.ClienteEmpresaStores.ClearInputs();
    this.setState({ isActive: false });
  };

  handleOpenModal = async () => {
    this.props.ClienteEmpresaStores.ClearInputs();
    this.setState({ arrayUsuarios: this.props.empresa.user });

    if (this.props.empresa.user.length > 0) {
      let id = this.props.empresa.user[0].id.toString();
      let first_name = this.props.empresa.user[0].first_name;
      this.setState({ clienteId: id, clienteName: first_name });
    }
    const res = await Api.get('platform_all_users')
    this.setState({ clientes: res.data });

    this.props.ClienteEmpresaStores.nome_fantasia = this.props.empresa.nome_fantasia;
    this.props.ClienteEmpresaStores.razao_social = this.props.empresa.razao_social;
    this.props.ClienteEmpresaStores.cnpj = this.props.empresa.cnpj;
    this.props.ClienteEmpresaStores.phone = this.props.empresa.phone;
    this.setState({ isActive: true });
  };

  handleUpdateEmpresaCloseModal = (e) => {
    e.preventDefault();
    let idUsuario = this.arrayIdCliente();
    let id = this.props.empresa.id;
    this.props.ClienteEmpresaStores.setAdminUser(this.state.arrayUsuarios.find(user => user.is_superuser))
    if (this.props.ClienteEmpresaStores.ChecksInputs(idUsuario)) {
      this.props.ClienteEmpresaStores.UpdateEmpresasId(id, idUsuario, this.state.clienteId);
      this.setState({ isActive: false });
    }
  };

  onChangeCliente = (e) => {
    this.setState({ valueCliente: e.target.value });
  };

  handleListaCliente = (e) => {
    this.setState({ status: true });
  };

  handleCloseListaClientes = () => {
    if (this.state.status) {
      this.setState({ valueCliente: "" });
    }
    this.setState({ status: !this.state.status });
  };

  removarUserLista = (user) => {
    if (user.is_superuser) {
      return AlertaError("Usuário administrador não pode ser excluído!");
    }
    let dados = [...this.state.clientes, user];
    this.setState({ clientes: dados });
    let newArray = [];
    newArray = this.state.arrayUsuarios.filter((item) => {
      return item.id !== user.id;
    });
    this.props.ClienteEmpresaStores.setAdminUser(newArray.find(user => user.is_superuser))
    this.setState({ arrayUsuarios: newArray });
  };

  searchClientes = (user) => {
    let newUser;
    newUser = user.filter((item) => {
      return (
        item.first_name
          .toLowerCase()
          .includes(this.state.valueCliente.toLowerCase()) ||
        item.username
          .toLowerCase()
          .includes(this.state.valueCliente.toLowerCase())
      )
    });
    return newUser.sort((a, b) =>
      a.first_name > b.first_name ? 1 : b.first_name > a.first_name ? -1 : 0
    );
  };

  handleLista = (cliente) => {
    this.setState({ arrayUsuarios: [...this.state.arrayUsuarios, cliente] });
    let newArray = [];
    newArray = this.state.clientes.filter((item) => {
      return item.id !== cliente.id;
    });
    
    this.setState({ clientes: newArray });
  };

  arrayIdCliente = () => {
    let dados = [];
    this.state.arrayUsuarios.map((item) => {
      return (dados = [...dados, item.id]);
    });
    return dados;
  };

  render() {
    const { razao_social, nome_fantasia, cnpj, phone } = this.props.empresa;
    const { onChange } = this.props.ClienteEmpresaStores;
    return (
      <span>
        <ButtonGroup aria-label="Basic example">
          <Button
            style={{ fontSize: "10px" }}
            size="sm"
            variant="warning"
            onClick={() => this.handleOpenModal()}
            title="EDITAR REGISTRO"
          >
            <FontAwesomeIcon style={{ color: "white" }} icon={"edit"} />{" "}
          </Button>
        </ButtonGroup>
        <Modal
          className="Modal_Load"
          style={{
            content: {
              width: "800px",
              height: "700px",
              left: "47%",
              top: "43%",
            },
          }}
          overlayClassName="Overlay_Load"
          isOpen={this.state.isActive}
        >
          <ModalHeard
            icon={"briefcase"}
            titulo={"EDITAR EMPRESA"}
            onClick={() => this.handleCloseModal()}
          />
          <br />
          <div>
            <Col md={12} style={{ marginTop: "1%" }}>
              <Form>
                <Form.Group controlId="formBasicEmail">
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="inputGroupPrepend">
                        <FontAwesomeIcon icon={"user-circle"} />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      name={"nome_fantasia"}
                      type="text"
                      placeholder="nome fantasia"
                      defaultValue={nome_fantasia}
                      onChange={(e) => onChange(e)}
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group controlId="formBasicEmail">
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="inputGroupPrepend">
                        <FontAwesomeIcon icon={"user-circle"} />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      name={"razao_social"}
                      type="text"
                      placeholder="razão social"
                      defaultValue={razao_social}
                      onChange={(e) => onChange(e)}
                    />
                  </InputGroup>
                </Form.Group>

                <div style={{ display: "flex", width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "98%",
                      marginRight: "10px",
                    }}
                  >
                    <div style={{ display: "flex", width: "100%" }}>
                      <InputGroup.Text
                        style={{ height: "41px", width: "42px" }}
                        id="inputGroupPrepend"
                      >
                        <FontAwesomeIcon icon="code" />
                      </InputGroup.Text>
                      <InputMask
                        name={"cnpj"}
                        defaultValue={cnpj}
                        style={{
                          marginLeft: "-0.7%",
                          width: "100%",
                          border: "1.2px",
                          borderRadius: "4px",
                          height: "41px",
                          borderColor: "#ced4da",
                          borderStyle: "solid",
                        }}
                        mask="   99.999.999/9999-99"
                        maskChar={null}
                        placeholder="  cnpj.."
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "98%",
                      marginLeft: "10px",
                    }}
                  >
                    <div style={{ display: "flex", width: "100%" }}>
                      <InputGroup.Text
                        style={{ height: "41px", width: "42px" }}
                        id="inputGroupPrepend"
                      >
                        <FontAwesomeIcon icon="phone-square" />
                      </InputGroup.Text>
                      <InputMask
                        name={"phone"}
                        defaultValue={phone}
                        style={{
                          marginLeft: "-0.7%",
                          width: "100%",
                          border: "1.2px",
                          borderRadius: "4px",
                          height: "41px",
                          borderColor: "#ced4da",
                          borderStyle: "solid",
                        }}
                        mask="   (99) 99999-9999"
                        maskChar={null}
                        placeholder="  telefone.."
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "10px" }}>
                  {" "}
                  {FormLabelModal("lista de usuarios")}
                </div>
                <div
                  className="select"
                  style={{
                    display: "flex",
                    width: "100%",
                    flexWrap: "wrap",
                    border: "1px solid #ced4da",
                    maxHeight: "150px",
                    overflow: "auto",
                    minHeight: "40px",
                  }}
                >
                  {this.state.arrayUsuarios.map((user) => {
                    return (
                      <div
                        style={{
                          width: "auto",
                          height: "28px",
                          borderRadius: "7px",
                          background: user.is_superuser ? "#dc3545" : "#54a0ff",
                          color: "white",
                          padding: "5px 5px 5px 15px",
                          fontSize: "12px",
                          margin: "5px",
                        }}
                      >
                        {user.first_name} {user.is_superuser && ' (ADMIN)'}
                        <span
                          style={{ marginLeft: "10px" }}
                          onClick={() => this.removarUserLista(user)}
                        >
                          <X
                            className="icon-scale icon-scale:hover"
                            size={"13px"}
                          />
                        </span>
                      </div>
                    );
                  })}
                </div>

                <div style={{ marginTop: "20px" }}>
                  <Form.Group controlId="formBasicEmail">
                    {FormLabelModal("adicionar usuarios")}
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text id="inputGroupPrepend">
                          <FontAwesomeIcon icon={"user-circle"} />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <Form.Control
                        onClick={(e) => this.handleListaCliente(e)}
                        onChange={(e) => this.onChangeCliente(e)}
                        name={"cliente"}
                        value={this.state.valueCliente}
                        type="text"
                        placeholder="Selecione um Usuario"
                      />
                    </InputGroup>
                  </Form.Group>
                  {this.state.status && (
                    <div className="select-search-box__select_novo box">
                      <ul className="select-search-box__options box">
                        {this.state.loading ? <div style={{ textAlign: 'center', marginTop: '3rem' }}>Carregando...</div>
                          : this.searchClientes(this.state.clientes).map(
                            (usuario) => {
                              return (
                                <DivUser
                                  role="menuitem"
                                  className="select-search-box__option select-search-box__row"
                                  data-value="annie.cruz"
                                  onClick={() => {
                                    this.handleLista(usuario);
                                  }}
                                >
                                  <div>{usuario.first_name}</div>
                                  <div className="user-mail">{usuario.email}</div>
                                </DivUser>
                              );
                            }
                          )}
                      </ul>
                    </div>
                  )}
                </div>
                <div
                  onClick={() => this.handleCloseListaClientes()}
                  style={{ textAlign: "center" }}
                >
                  {this.state.status ? (
                    <ChevronsUp
                      color={"#3a566e"}
                      className="icon-scale icon-scale:hover"
                    />
                  ) : (
                    <ChevronsDown
                      color={"#3a566e"}
                      className="icon-scale icon-scale:hover"
                    />
                  )}
                </div>

                <div style={{ textAlign: "right" }}>
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={(e) => this.handleUpdateEmpresaCloseModal(e)}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => this.handleCloseModal()}
                    style={{ marginLeft: "10px" }}
                  >
                    Fechar
                  </Button>
                </div>
              </Form>
            </Col>
          </div>
          {BottomModal}
        </Modal>
      </span>
    );
  }
}
export default ModalEditarEmpresaHome;
